import { Notification } from "./notification.model";

export class NotificationResponse {
  content: Notification[] = [];
  //@ts-ignore
  totalElements: number;
  //@ts-ignore
  size: number;
}